import * as React from "react"
import "twin.macro"
import { graphql, Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

export default function Hero() {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "homepage_hero_bg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <div tw="lg:relative bg-white">
      <div tw="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
        <div tw="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
          <h2 tw="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl lg:text-5xl xl:text-6xl">
            Welcome to <br tw="xl:hidden" />
            <span tw="text-blue-600">Monta Vista FBLA</span>
          </h2>
          <p tw="mt-3 max-w-md mx-auto text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            Founded in 2001, the Monta Vista High School chapter of the largest
            global career-technical organization prepares students for fulfilling 
            careers in business, entrepreneurship, and beyond.
          </p>
          <div tw="mt-10 sm:flex sm:justify-center lg:justify-start">
            <div tw="rounded-md shadow">
              <a
                href="https://forms.gle/Avx9YJeGEKHqYGhK7"
                target="_blank"
                tw="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
              >
                Join Us
              </a>
            </div>
            <div tw="mt-3 rounded-md sm:mt-0 sm:ml-3">
              <a
                href="#"
                tw="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-blue-700 bg-blue-100 hover:text-blue-600 hover:bg-blue-50 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
      <div tw="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
        <Img
          tw="absolute inset-0 w-full h-full object-cover"
          fluid={data.file.childImageSharp.fluid}
        />
      </div>
    </div>
  )
}
